/** Name of the webpack bundle for the site */
// "as const" means the type of the constant will literally be "fabric-site" not string
// (allows referencing the type in JS even if the package hasn't been built)
export var BUNDLE_NAME = 'fabric-site';
/** Format for the manifest file name. `{major}` is the major version number and `{suffix}` is `df` or `prod`. */
export var MANIFEST_NAME_FORMAT = 'v{major}-{suffix}.js';
/** Suffixes for manifest files */
export var MANIFEST_VARIANTS = ['prod', 'df'];
//# sourceMappingURL=constants.js.map